import { render, staticRenderFns } from "./AddCompound.vue?vue&type=template&id=4664f6de&"
import script from "./AddCompound.vue?vue&type=script&lang=js&"
export * from "./AddCompound.vue?vue&type=script&lang=js&"
import style0 from "./AddCompound.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports